<template>
  <div
    v-if="transfers.length > 0"
    class="tag-wrapper"
    @mouseleave="showTable = false"
    @click="showTable = true"
  >
    <span
      class="label tag-transfer table-tag-content"
      :class="{ colorOnline: colorOnlineTr }"
    >
      <!--          @click="filterMain"-->
      <span
        :class="{
          'mia-color': transfers[0].by_user.id == 44,
          'paul-color': transfers[0].by_user.id == 46,
          'sofia-color': transfers[0].by_user.id == 45
        }"
        class="tagNameDesign"
        >{{ transfers[0].by_user.first_name.substr(0, 2) }}</span
      ><span v-if="transfers.length > 1">#{{ transfers.length }}</span
      ><a @click.prevent="$emit('delete')"
        ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span
      ></a>
      {{ formatDate(transfers[0].created_at) }}
    </span>

    <div
      v-if="showTable"
      class="tag-table pop-up-for-tags"
      @click="showTable = false"
    >
      <!--      @mouseenter="showTable = false"-->

      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th class="t-header">DATE</th>
              <th class="t-header">TIME</th>
              <th class="t-header">AGENT</th>
              <th class="t-header">TYPE</th>
              <th class="t-header">FROM</th>
              <th class="t-header">TO</th>
              <th class="t-header" v-if="transfers.to_place_idx">Idx</th>
              <th>
                <i
                  @mouseenter="showTable = false"
                  class="fa fa-times"
                  aria-hidden="true"
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="trans in transfers" :key="trans.id">
              <td>
                <span
                  :class="{
                    inBetweenSelectedCalDates: checkSelectedCalDates(trans)
                  }"
                  >{{ formatDateTable(trans.created_at) }}</span
                >
              </td>
              <td>
                {{ trans.created_at | shortTime }}
              </td>
              <td>{{ trans.by_user.full_name }}</td>
              <td>
                <strong v-if="trans.type !== null">{{
                  trans.type.name
                }}</strong>
                <strong v-else>Doesn't Mentioned</strong>
              </td>
              <td>{{ trans.from_user.full_name }}</td>
              <td>{{ trans.to_user.full_name }}</td>
              <td v-if="trans.to_place_idx !== null">
                <b>{{ trans.to_place_idx }}</b>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "Transfer",
  props: {
    transfers: {
      type: Array,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      showTable: false,
      isOnline: false,
      colorOnlineTr: false
    };
  },
  computed: {
    ...mapState("clients", ["salesPersonList", "generalQueryObject"])
  },
  mounted() {
    this.checkIt();
  },

  methods: {
    checkSelectedCalDates(trans) {
      // console.log(this.queryObject)
      // console.log(trans)
      // console.log(this.generalQueryObject)
      let trIn = moment(trans.created_at);
      let start = moment(this.generalQueryObject.last_transfer_from).startOf(
        "day"
      );
      let to = moment(this.generalQueryObject.last_transfer_to).endOf("day");
      // // console.log(depIn+ " "+ "dep");
      // // console.log(start+ " "+ "start");
      // // console.log(to+ " "+ "to");
      if (trIn.isBetween(start, to)) {
        return true;
      } else {
        return false;
      }
    },
    // filterMain() {
    //   this.$store.commit("clients/setFilterToMain", {
    //     title: "tr",
    //     type: true
    //   });
    // },
    checkIt() {
      this.transfers.forEach(e => {
        if (e.type.name === "Online Transfer") {
          this.colorOnlineTr = true;
        }
      });
    },
    findUser(id) {
      return this.salesPersonList.find(element => {
        return element.id === id;
      });
    },

    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM");
    },
    formatDateTable(date) {
      return moment(String(date)).format("DD/MM/YY");
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-wrapper {
  display: inline-flex;
  position: relative;
}

.tag-transfer {
  background-color: #ceb800;
  /*font-size: 12px;*/
  /*color: white;*/
  /*!*font-size: 11px;*!*/
  /*margin: 2px;*/
  /*!*padding: 3px;*!*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
  /*font-family: Montserrat !important;*/
  /*font-weight: 500;*/
  /*animation: flash linear 1s;*/
  /*height: 178px;*/
}
.table {
  margin-bottom: 0px !important;
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

.tag-table {
  border: solid 1px #ab9b0c;
  bottom: 34px !important;
  text-align: center;
  max-height: 267px;
  overflow-y: hidden;
}

.table-responsive {
  margin-bottom: 0px;
  border-radius: 5px;

  overflow: auto;
  max-height: 267px;
}

.tag-time {
  font-size: 11px;
}

.remove-tag-icon {
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 5px;*/
  color: white;
  cursor: pointer;
  margin-left: 0px;
  position: absolute;
  left: 11px;
  font-size: 17px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 6px;
  padding-right: 6px;
  border: 1px solid black;
  border-radius: 5px;
  top: 6px;
  background: black;
}
.remove-tag-icon:hover {
  color: white;
  background: black;
}
/*.remove-tag-icon:hover {*/
/*  color: #f44336;*/
/*}*/
.label {
  padding: 4px 2px 4px 2px;
  font-size: 12px;
}
.colorOnline {
  background-color: #ab9b0c;
}
.tagNameDesign {
  text-transform: uppercase;
  /*margin-left: 1px !important;*/
}
.mia-color {
  background-color: #e85e73;
  padding: 3.5px;
  padding-left: 5px !important;
  font-size: 11.5px !important;
}
.paul-color {
  background-color: lightslategray;
  padding: 3.5px;
  font-size: 11.5px !important;
}
.sofia-color {
  background-color: #ee82ee;
  padding: 3.5px;
  font-size: 11.5px !important;
}
.tagNameDesign:hover {
  font-size: 12.3px !important;
}
.inBetweenSelectedCalDates {
  color: blue;
}
tbody > tr:nth-of-type(odd) {
  background-color: #7a7a7a0d;
}
.t-header {
  position: sticky;
  top: 0;
  background-color: white !important;
}
/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}
th.t-header {
  z-index: 2;
}
.fa-times {
  cursor: pointer;
}
</style>
